@if ({ data: displayData$ | async, translations: translations$ | async, listLoader: listLoader$ | async }; as $) {
    <adspt-selector-button
        [ngClass]="{ 'disabled-close': disableReset, 'multi-selector': $.data.multpleSelections }"
        nz-dropdown
        nzTrigger="click"
        [(nzVisible)]="isVisible"
        [nzDropdownMenu]="menu"
        [nzClickHide]="false"
        adsptHeap="groups-global-selector"
        [heapDisabled]="isVisible"
        [showLoader]="loader$ | async"
        [dataParams]="PGparams"
        [defaultLabel]="$.translations.title"
        [showDefaultLabel]="
            $.data.src.type === 'LABEL' && (hasDestinationSelector ? $.data.dest.type === 'LABEL' : true)
        "
        [label]="$.data.src.payload || $.translations.title"
        [selectionLabels]="$.data.labels.buttonTexts"
        [tooltip]="$.data.labels.tooltip"
        [isOpen]="isVisible"
        (closed)="reset.emit({})"
        (nzVisibleChange)="onDropDownVisibiltiyChange($event)"
    />
    <nz-dropdown-menu #menu="nzDropdownMenu">
        @if (isVisible) {
            <div class="dialog-wrapper">
                <adspt-global-selector-dialog-content
                    [isVisible]="isVisible"
                    [hasDestinationSelector]="hasDestinationSelector"
                    [selectedTabIndex]="selectedTabIndex"
                    [enableAdvancedMode]="enableAdvancedMode"
                    [enableAdvancedFilterSelection]="enableAdvancedFilterSelection"
                    [subfilterOptions]="subfilterOptions"
                    [obs]="$"
                    [rowItemTmpl]="rowItemTmpl"
                    [srcList]="srcList$"
                    [destList]="destList$"
                    [srcTotalCount]="srcTotalCount$"
                    [destTotalCount]="destTotalCount$"
                    [hasSrcQuery]="hasSrcQuery$"
                    [hasDestQuery]="hasDestQuery$"
                    [heapInfo]="heapInfo"
                    (selectedTabIndexChange)="selectedTabIndex = $event"
                    (notfiy)="onNotifications($event.evt, $event.filterMode)"
                    (refinerChange)="onRefinerChange($event.evt, $event.filterMode)"
                >
                </adspt-global-selector-dialog-content>
            </div>
        }
    </nz-dropdown-menu>
    <ng-template #rowItemTmpl let-data>
        <div class="type-logo a-fx-none" [ngClass]="'bg-' + data.type">
            <svg class="adspt-icon type">
                <use [attr.xlink:href]="'#adspt-' + data.type | lowercase"></use>
            </svg>
        </div>
        <div class="a-fx a-fx-between-center a-fx-gap-16 a-fx-flex">
            <div class="a-fx-col">
                <p>{{ data.name }}</p>
                <div class="caption-1">
                    {{
                        ('global-filter.sub-filters.' + data.type | translate) +
                            ' ' +
                            ('global-filter.group-selector.pg' | translate)
                    }}
                </div>
            </div>
            @if (data.id === $.data.selectedItems[selectedTabIndex ? filterMode.Destination : filterMode.Source]) {
                <svg
                    nz-tooltip
                    [nzTooltipTitle]="'common.remove-selected-item' | translate"
                    class="adspt-icon close-icon"
                    (click)="
                        $event?.stopPropagation();
                        reset.emit({ tab: selectedTabIndex ? filterMode.Destination : filterMode.Source })
                    "
                >
                    <use xlink:href="#adspt-cross-circle"></use>
                </svg>
            }
        </div>
    </ng-template>
}
